<div class="hvac-video-widget">
    <ul class="hvac-row hvac-video-list">
        <li *ngFor="let video of data?.Content?.list.$values;trackBy: trackByFn" class="hvac-rhythm-4">
            <a href="{{video.Content.links?.linkExternal}}"
                rel="noopener noreferrer" target="_blank"
                class="hvac-video-link">
                <div class="hvac-thumb-constraint">
                    <img [src]="video.Content.primaryMedia.BinaryContent.Url" alt="{{video.Content.primaryMedia.ExternalContent.Metadata.SecureUri}}" class="hvac-video-thumbnail">
                </div>
                <div class="hvac-video-details">
                    <span class="hvac-video-play-symbol">
                        <utc-svg src="assets/icons/play.svg" class="hvac-play-icon"></utc-svg>
                    </span>
                    <p class="hvac-video-title" [innerHTML]="video.Content.title | richText"></p>
                </div>
            </a>
        </li>
    </ul>
</div>
